import SignInForm$1, { Fields, Submit, Errors } from './SignInForm.js';

const SignInForm = Object.assign(SignInForm$1, {
    Fields,
    Submit,
    Errors,
});

export { SignInForm };
